// extracted by mini-css-extract-plugin
export var header = "_uf-1";
export var maskBottom = "_uf-6";
export var maskMiddle = "_uf-7";
export var maskTop = "_uf-5";
export var root = "_uf-0";
export var scrollDownButton = "_uf-3";
export var scrollDownButtonHidden = "_uf-4";
export var viewport = "_uf-2";